export default{
    state:{//页面需要的状态之前在页面的data中定义

    },
    getters:{//state中数据的计算属性，组件中的computed

    },
    actions:{//异步操作请求数据

    },
    mutations:{//唯一改变数据的方式 可以在action中调用，也可以在组件中调用

    }
}


// WEBPACK FOOTER //
// ./src/store/componyProduct.js